/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row3_LinearInputs */

const en_mk_cmp_row3_linear = /** @type {(inputs: Mk_Cmp_Row3_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A spend limit, not an action gate`)
};

const id_mk_cmp_row3_linear = /** @type {(inputs: Mk_Cmp_Row3_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plafon biaya, bukan gerbang aksi`)
};

/**
* | output |
* | --- |
* | "A spend limit, not an action gate" |
*
* @param {Mk_Cmp_Row3_LinearInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row3_linear = /** @type {((inputs?: Mk_Cmp_Row3_LinearInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row3_LinearInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row3_linear(inputs)
	return en_mk_cmp_row3_linear(inputs)
});